const Emoji_N = {
    ':nerd': { id: 35, width: 20, height: 20 },
    ':new': { id: 360, width: 30, height: 26 },
    ':newconfus': { id: 359, width: 18, height: 26 },
    ':ninja': { id: 361, width: 20, height: 20 },
    ':no_1': { id: 362, width: 20, height: 20 },
    ':no': { id: 364, width: 20, height: 20 },
    ':noexpression': { id: 363, width: 18, height: 18 },
    ':noimageemot': { id: 365, width: 38, height: 18 },
    ':nono': { id: 366, width: 23, height: 25 },
    ':nosweat': { id: 367, width: 19, height: 18 },
    ':notify': { id: 368, width: 20, height: 27 },
    ':notinlove': { id: 592, width: 18, height: 18 },
    ':notworthy': { id: 369, width: 33, height: 25 },
    ':novicok': { id: 370, width: 31, height: 31 },
    ':nuhh': { id: 600, width: 40, height: 18 },
    ':nuke': { id: 371, width: 20, height: 20 },
}

export default Emoji_N
